<template>
  <div class="Investment-box equities-box">
    <div class="head-text">
      <ul class="breadcrumbs-list">
        <a href="javascript:void(0)" @click="landingPage"><li>Dashboard</li></a>
        <a href="javascript:void(0)" @click="backToCategory"><li>&nbsp;>&nbsp;Category</li></a>
        <li>&nbsp;>&nbsp;{{ type }}</li>
      </ul>
      <h1>{{ type }}</h1>
 
      <div class="search-box">
        <v-text-field
                  v-model="search"
                  id="search_article"
                  name="search_article"
                  append-icon="mdi-magnify"
                  label="Search"
                  class="searched"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
                <v-btn class="search-btn" @click="searchArticle()">Search</v-btn>

      </div> 
    </div>
    <div class="card-box equities-section">
      <div class="d-flex justify-space-between">
        <div class="equities-item">
          <v-row>
            <template>
              <v-card
                class="mx-auto"
                outlined
                v-for="(article_list_item,index) in article_list" :key="index"
              >
                <v-list-item three-line>
                  <v-list-item-content>
                    <div class="d-flex">
                      <div class="imgfield">
                        <v-img
                          max-height="60"
                          max-width="60"
                          :src="titleIcon"
                          :lazy-src="titleIcon"
                        >
                        </v-img>
                      </div>
                      <div class="contentfield">
                        <v-list-item-title>{{
                          article_list_item.title
                        }}</v-list-item-title>
                        <v-list-item-subtitle
                          >Published:
                          {{
                            article_list_item.created_at
                          }}</v-list-item-subtitle
                        >
                        <a
                          class="fullArtical"
                          @click="readArticle(article_list_item)"
                          >Read full article</a
                        >
                      </div>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </template>
          </v-row>
          <!-- <div class="social-icon-box">
            <h2>Follow Nimeya on</h2>
            <div class="d-flex justify-center">
              <div class="imgbox">
                <a href="https://www.facebook.com/nimeyaai/"
                    target="blank"><v-img max-height="30" max-width="30" :src="facebook">
                  </v-img
                ></a>
              </div>
              <div class="imgbox">
                <a href="https://www.instagram.com/nimeya.ai/"
                    target="blank"><v-img max-height="30" max-width="30" :src="insta"> </v-img
                ></a>
              </div>
              <div class="imgbox">
                <a href="https://www.linkedin.com/company/nimeya-ai/"
                    target="blank"><v-img max-height="30" max-width="30" :src="linked"> </v-img
                ></a>
              </div>
              <div class="imgbox">
                  <a href="https://nimeya.ai/"
                    target="blank"><v-img max-height="30" max-width="30" :src="website"> </v-img></a>
                </div>
            </div>
            <p>Send your feedback to:<span><a href="mailto:support@nimeya.ai">support@nimeya.ai</a></span></p>
          </div> -->
        </div>
        <div class="equities-item-box">
          <template>
            <v-card
              v-for="categoryList in category"
              :key="categoryList.id"
              class="mx-auto"
              outlined
              @click="otherArticleLists(categoryList.id, categoryList.type)"
            >
              <v-list-item three-line>
                <v-list-item-content>
                  <div class="overline">
                    <v-img
                      max-height="39"
                      max-width="39"
                      :src="webIcon + categoryList.web_icon"
                    >
                    </v-img>
                  </div>
                  <v-list-item-title>{{ categoryList.type }}</v-list-item-title>
                </v-list-item-content>
                <v-btn
                  @click="otherArticleLists(categoryList.id, categoryList.type)"
                  text
                >
                  <v-img
                    max-height="30"
                    max-width="30"
                    src="https://dev-api.nimeya.ai/img/icons/forword_arrow.png"
                  >
                  </v-img>
                </v-btn>
              </v-list-item>
            </v-card>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data: function () {
    return {
      arrowRight: './bondimg.png',
      facebook: './facebook.svg',
      insta: './instagram.svg',
      linked: './linkedin.svg',
      website:'./domain.svg',
      category: [], 
      search: '',
      article_list: [],
      webIcon: process.env.VUE_APP_ROOT_ICONS_URL,
      titleIcon: '',
      type: this.$route.params.category_name,
      finstat_cat_id: this.$route.params.category,
      similar_article_list: [],
      mai_cat: [],
      title:''
    };
  },
  mounted() {
    this.type = localStorage.getItem('category_name')
    this.finstat_cat_id = localStorage.getItem('category')
    this.getArticalList();
  },
  methods: {
    backButton() {
      this.$router.push({ name: 'SudLifeFinStatCategory' }).catch(() => {});
    },
    backToCategory(){
       this.$router.push({ name: "SudLifeFinStatCategory"}).catch(()=>{});
    },
    readArticle(item) {
      localStorage.setItem('article_id', item.id);
      localStorage.setItem('category_name', this.type);
      localStorage.setItem('category', localStorage.getItem('category'));
      localStorage.setItem('title', item.title);

      this.$router.push({
          name: 'SudLifeReadFullFinstatArticle',
          params: { category: this.cat_id,category_name: this.type,article_id:this.article_id,img:this.img, title: this.title, props: true },
      });  
    },
    otherArticleLists(category_id, type) {
      setTimeout(() => {
        this.category = [];
        this.mai_cat.forEach((element) => {
          if (element.id != this.finstat_cat_id) {
            this.category.push(element);
          }
        });
      }, 500);
      this.articleList(category_id);
      this.type = type;
      this.finstat_cat_id = category_id;
    },
    getArticalList() {
      let cognito_idp = atob(localStorage.getItem('cognito_idp'));
      let formCatData = new FormData();
      formCatData.append('aws_cognito_id', cognito_idp);
      axios
        .post(
          process.env.VUE_APP_ROOT_API + 'finstat-categories-listing',
          formCatData,
          {
            headers: { 
              'Content-Type': 'multipart/form-data',
              'Access-Control-Allow-Origin': '*',
            },
          }
        )
        .then((response) => {
          this.category = [];
          response.data.data.forEach((element) => {
            if (element.id != this.finstat_cat_id) {
              this.category.push(element);
            }
          });
          this.mai_cat = response.data.data;
        });
      this.articleList(this.$route.params.category);
    },

    articleList(cat_id) {
      let cognito_idp = atob(localStorage.getItem('cognito_idp'));
      let formdata = new FormData();
      formdata.append('aws_cognito_id', cognito_idp);
      formdata.append('cat_id', cat_id);
      axios
        .post(
          process.env.VUE_APP_ROOT_API + 'get-finstat-category-articals',
          formdata,
          {
            headers: {
              'Access-Control-Allow-Origin': '*',
            },
          }
        )
        .then((response) => {
          this.article_list = response.data.data;
          this.titleIcon =
            process.env.VUE_APP_ROOT_ICONS_URL +
            response.data.cat_detail.web_icon;
            console.log(this.titleIcon,response.data.cat_detail.web_icon,"Image not show")
        });
    },

    searchArticle(){
      let formCatData = new FormData();
      formCatData.append('title', document.getElementById('search_article').value);
      formCatData.append('finstat_cat_id', this.finstat_cat_id);
      axios
        .post(
          process.env.VUE_APP_ROOT_API + 'search-finstat-article',
          formCatData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Access-Control-Allow-Origin': '*',
            },
  
          }
        )
        .then((response) => {
          this.article_list = []
          this.article_list  = response.data.data
      });
    },

    landingPage(){
      this.$router.push({ name: "SudLifeLandingPage", query: { q: localStorage.getItem('q'), s: localStorage.getItem('s') },}).catch(()=>{});
    }
  },
};
</script>
<style>
.searched {
  padding: 0px;
  width: 0px;
}
.search-btn {
  background-color: #d98f07 !important;
  color: #fff !important;
  height: 46px !important;
  margin-left: 10px;
  /* font-family: Work Sans, sans-serif; */
  font-weight: bold;
  min-width: 150px !important;
}


.search-box {
  max-width: 60%;
  width: 100%;
  margin-right: 0;
  margin-left: auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 20px;
}

.social-icon-box p {
    opacity: 1 !important;
  }

@media only screen and (max-width: 767px) {
  .equities-section .d-flex {
    flex-wrap: wrap;
  }

  .equities-item,search-box, .equities-item-box, .equities-box .card-box .v-card {
    width: 100% !important;
  }

  .search-box {
    max-width: unset;
  }

  .search-box .search-btn {
    height: 40px !important;
    max-width: 25%;
    min-width: 70px !important;
  }
}  
</style>
